import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=0b0b3fbe&scoped=true&"
import script from "./Feedback.vue?vue&type=script&lang=js&"
export * from "./Feedback.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/feedback.scss?vue&type=style&index=0&id=0b0b3fbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0b3fbe",
  null
  
)

export default component.exports